"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentComponent = exports.PrimaryActionType = void 0;
var React = require("react");
var Localize_1 = require("../gen-src/Localize");
var ButtonsComponent_1 = require("./ButtonsComponent");
var ExpandoHelpComponent_1 = require("./ExpandoHelpComponent");
var ProtocolHelper_1 = require("./ProtocolHelper");
var DialogStyles_1 = require("./styles/DialogStyles");
var PrimaryActionType;
(function (PrimaryActionType) {
    PrimaryActionType[PrimaryActionType["CloseDialogOnly"] = 0] = "CloseDialogOnly";
    PrimaryActionType[PrimaryActionType["CloseDialogAndWorkbook"] = 1] = "CloseDialogAndWorkbook";
})(PrimaryActionType = exports.PrimaryActionType || (exports.PrimaryActionType = {}));
var ContentComponent = /** @class */ (function (_super) {
    __extends(ContentComponent, _super);
    function ContentComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.buttonsProps = _this.createButtonProps();
        return _this;
    }
    ContentComponent.prototype.componentDidMount = function () {
        (0, ProtocolHelper_1.OpenTableau)(this.props.workbookInfo);
    };
    ContentComponent.prototype.render = function () {
        return (React.createElement("div", { className: DialogStyles_1.DialogStyles.DialogContent },
            React.createElement("p", { className: DialogStyles_1.DialogStyles.HelpText }, Localize_1.Messages.HelpText()),
            React.createElement(ExpandoHelpComponent_1.ExpandoHelpComponent, { isTableauOnline: this.props.isTableauOnline }),
            React.createElement(ButtonsComponent_1.ButtonsComponent, __assign({}, this.buttonsProps))));
    };
    ContentComponent.prototype.createButtonProps = function () {
        var _this = this;
        return {
            workbookInfo: this.props.workbookInfo,
            handlePrimaryAction: function () {
                _this.props.handlePrimaryAction();
            },
            primaryButtonLabel: this.props.primaryActionButtonLabel,
        };
    };
    return ContentComponent;
}(React.PureComponent));
exports.ContentComponent = ContentComponent;
//# sourceMappingURL=ContentComponent.js.map